// extracted by css-extract-rspack-plugin
export default {"colleaguesTooltipList":"CellTooltip_colleaguesTooltipList__qxehK","colleaguesTooltipItem":"CellTooltip_colleaguesTooltipItem__yNhOs"};